module.exports = __webpack_public_path__ + "img/Pic_Text_SFY_Down.5909c661.png";